import { useState } from "react";
import OtpInput from "react-otp-input";
import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import type { SignInResponse } from "@circle-react/hooks/useVerifyOtp";
import { useVerifyOtp } from "@circle-react/hooks/useVerifyOtp";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";

export interface CurrentCommunityContextType {
  userEmail: string;
  isSignupPasswordMatching: boolean;
}

export interface OtpSignInFormProps {
  setOtpSignInResponse: (response: SignInResponse) => void;
}

export const OtpSignInForm = ({ setOtpSignInResponse }: OtpSignInFormProps) => {
  const result: CurrentCommunityContextType = useCurrentCommunityContext();
  const { userEmail, isSignupPasswordMatching } = result;
  const localeScope = "authentication_app.signin.form";
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const { mutateAsync: handleSubmit } = useVerifyOtp({
    setIsVerifyingOtp,
    isSignupPasswordMatching,
    setOtpSignInResponse,
  });

  const otpInputStyle = {
    border: "1px solid var(--grey-200, #E4E7EB);",
    borderRadius: "8px",
    width: "54px",
    height: "64px",
    color: "#000",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "28px",
  };

  const otpInputFocusStyle = {
    border: "1px solid #CFD3DB",
    outline: "none",
  };

  const handleChange = (code: any) => setOtp(code);

  return (
    <Form
      onSubmit={async (): Promise<void> => {
        await handleSubmit({
          user: {
            email: userEmail,
            otp: otp,
          },
        });
      }}
    >
      <Form.Item
        name="user[otp]"
        hiddenField
        hideDescription
        hideBorder
        hideLabel
      >
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={6}
          separator={<span style={{ width: "8px" }} />}
          isInputNum
          shouldAutoFocus
          inputStyle={otpInputStyle}
          focusStyle={otpInputFocusStyle}
        />
      </Form.Item>
      <Form.Item
        name="user[email]"
        hiddenField
        hideDescription
        hideBorder
        hideLabel
      >
        <Form.Input type="hidden" value={userEmail} />
      </Form.Item>
      <div className="mt-6 w-full text-center">
        <div className="mx-auto mb-4 flex w-full">
          <Button
            variant="primary"
            type="submit"
            full
            extraLarge
            disabled={isVerifyingOtp}
          >
            {t(`${localeScope}.submit`)}
          </Button>
        </div>
      </div>
    </Form>
  );
};
